<template>
  <modal
    :name="'deleteAccountModal'"
    :adaptive="true"
    height="auto"
    :width="500"
    transition="linear"
    id="deleteModal"
  >
    <modals-header
      :modalNameProp="$lang.messages.deleteAccountModalTitle"
      @hideModalProp="hideDeleteModal"
    >
    </modals-header>

    <hr class="v--modal-hr">

    <div class="fp-modal">
      <div>{{ $lang.messages.deleteAccountModalText }}</div>
      <button
          type="button"
          class="generic-btn"
          @click="hideDeleteModal"
      >
        {{ $lang.messages.deleteAccountModalBtnNo }}
      </button>
      <button
          type="button"
          class="action-btn btn-modal-delete"
          @click="deleteAccount()"
      >
        <span>{{ $lang.messages.deleteAccountModalBtnYes }}</span>
      </button>
    </div>
  </modal>
</template>

<script>
  import modalsHeader from "@/components/common/modals/ModalsHeader";
  import { mapActions } from "vuex";
  import { DELETE_ACCOUNT, LOGOUT } from "@/store/action.types";
  import STATUS_CODES from "@/common/statusCodes";

  export default {
    name: "DeleteAccountModal",
    components: {
      'modals-header': modalsHeader
    },
    methods: {
      ...mapActions({
        deleteAccountAction: DELETE_ACCOUNT,
        logoutAction: LOGOUT,
      }),
      show() {
        this.$modal.show('deleteAccountModal')
      },
      hideDeleteModal() {
        this.$modal.hide('deleteAccountModal')
      },
      deleteAccount() {
        this.deleteAccountAction()
        .then(() => {
          this.$snotify.success(this.$lang.messages.sn_accountDeletedSuccess, 'SUCCESS')
          this.logout();
        })
        .catch(error => {
          this.hideDeleteModal();
          if (error.response) {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(error.response.data.status.desc, 'ERROR')
            }
          }
        });
      },
      logout() {
        this.logoutAction().then(() => {
          this.$router.push({ name: "Login" })
        });
      },
    }
  }
</script>
